import { 
  Container,
  LogoutButton,
  MenuItem,
  MenuItemTitle,
  MenuItemLink,
  PreviousChatsContainer,
  ChatHistoryTitle,
  ConversationMenuItem,
  ConversationTitle,
  BottomContainer,
  ShadowContainer,
} from './styles';
import NewChatIcon from '../Icons/NewChatIcon';
import InstructionsIcon from '../Icons/InstructionsIcon';

const ChatbotMenuMobile = ({ handleLogout, conversations, currentConversation, startNewChat, fetchPreviousChat, isBotReplying }) => {
  const sortedConversations = conversations.sort((a, b) => Number(b.sessionId) - Number(a.sessionId));
  
  return (
    <Container>
      <MenuItem onClick={startNewChat} disabled={!currentConversation || isBotReplying}>
        <MenuItemTitle active='true'>New Chat</MenuItemTitle>
        <NewChatIcon />
      </MenuItem>
      {sortedConversations.length > 0 && (
        <ChatHistoryTitle>Previous Chat</ChatHistoryTitle>
      )}
      {sortedConversations.length > 0 ? (
          <PreviousChatsContainer>
              {sortedConversations.map(item => (
                <div key={item.conversationId}>
                  <ConversationMenuItem
                    selected={item.conversationId === currentConversation}
                    onClick={() => fetchPreviousChat(item.conversationId, item.sessionId)}
                  >
                    <ConversationTitle>
                      {item.title?.length > 24 ? `${item.title.slice(0, 24)}...` : item.title}
                    </ConversationTitle>
                  </ConversationMenuItem>
                </div>
              ))}
          </PreviousChatsContainer>
      ) : null}
      <ShadowContainer>
      <BottomContainer>
      <MenuItem>
        <MenuItemLink
          href="/"
          target="_blank" 
          rel="noopener noreferrer"
        >
          Instructions
        </MenuItemLink>
        <InstructionsIcon />
      </MenuItem>
      <LogoutButton onClick={handleLogout}>Log Out</LogoutButton>
      </BottomContainer>
      </ShadowContainer>
    </Container>
  );
};

export default ChatbotMenuMobile;
